/**
 系统管理--下载中心
 */
import React, { Component } from "react";
import moment from "moment";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import FormCore from "@/components/display/form/formCore";
import ScGridTable from "@/components/display/table/gridTableCore";
import monthPickerHoc from "../../hoc/form/monthPickerHoc";
import { getExportRecordsList } from "../../fetch/fetchApi";
// 国际化切换语言
import { useAuth } from "@/utils/utils";

@monthPickerHoc
// eslint-disable-next-line arrow-parens
@connect((state) => state)
class stubExportRecords extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.stubOrderInfo;
    this.layout = [
      "inline", // 横向布局
      "horizontal", // 纵向布局
    ];
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentWillMount() {
    this.init();
  }

  init() {
    this.formConfig = {
      childItems: [
        {
          type: "date",
          dateType: "rangeDateTime",
          placeholder: ["开始时间", "结束时间"],
          param: {
            name: "date",
            type: "array",
          },
          width: "200px",
          labelName: "创建时间",
          required: false,
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            useAuth("901801")
              ? {
                  btnType: "submit",
                  text: "查询",
                }
              : "",
          ],
        },
      ], // 设置表单元素
      layout: this.layout[0], // 设置布局 0： 横向布局， 1：弹窗布局 2： 全页表单布局
      formTarget: "grid", // 表单提交类型，设置grid则为更新grid
      defaultParams: {
        type: 1,
      },
      autoLoadGrid: !0, // 设置为false不触发加载grid
      context: this,
      tableKey: "stubExportRecordsTable",
    };
    this.setState({
      tableConfig: {
        tableColumns: [
          {
            name: "任务标题",
            key: "name",
            colType: "textCol",
            align: "center",
          },
          {
            name: "任务类型",
            key: "type",
            colType: "textCol",
            align: "center",
            render: (value) => {
              switch (value) {
                case 1:
                  return "订单导出";
                default:
                  return "--";
              }
            },
          },
          {
            name: "状态",
            key: "status",
            colType: "textCol",
            align: "center",
            render: (value) => {
              switch (value) {
                case 1:
                  return "生成中";
                case 2:
                  return "已生成";
                case 3:
                  return "生成失败";
                default:
                  return "--";
              }
            },
          },
          {
            name: "创建时间",
            key: "createTime",
            colType: "textCol",
            align: "center",
          },
          {
            name: this.internationalization.action, // '操作',
            key: "action",
            fix: "right",
            colType: "action",
            actionMap: [
              useAuth("901802")
                ? {
                    type: "href",
                    // actionName: "下载",
                    render: (record) => {
                      // 状态 1-生成中 2-已生成 3-生成失败
                      if (record.status === 2) {
                        return <a href={record.filePath}>下载</a>;
                      } else {
                        return (
                          <a style={{ color: "#00000040" }} disabled>
                            下载
                          </a>
                        );
                      }
                    },
                    handler: (res) => {},
                  }
                : "",
            ],
          },
        ],
        tableChange: () => {},
        tableParam: {},
        tableInfo: {
          hasRow: !1, // 是否显示checkbox
        },
        autoRefresh: !1, // 设置为true 直接加载grid数据
        dataApi: getExportRecordsList,
        tableKey: "stubExportRecordsTable",
      },
    });
  }

  fetchApi = (params) => {
    let result = {
      ...params,
      type: 1,
    };
    if (params.date) {
      const date = params.date.split(",");
      (result.createTimeStart = `${moment(date[0]).format("YYYY-MM-DD HH:mm:ss")}`),
        (result.createTimeEnd = `${moment(date[1]).format("YYYY-MM-DD HH:mm:ss")}`),
        delete result.date;
    }
    return result;
  };

  render() {
    return (
      <div className="sc-page-content">
        <div className="page-toolbar">
          <FormCore formConfig={this.formConfig} fetchApi={this.fetchApi} />
        </div>
        <div className="page-panel gzsbTable">
          <ScGridTable config={this.state.tableConfig} />
        </div>
      </div>
    );
  }
}

export default injectIntl(stubExportRecords);



// WEBPACK FOOTER //
// ./src/AntD/pages/system/downloadCenter.js